import {isNotNil} from 'ramda';

import {useEagGridSelector} from '../store/useEagGridSelector';
import {useEagGridStore} from '../store/useEagGridStore';
import type {EagColumn} from '../types/EagColumn';
import {copyRowsToClipboard} from '../utils/copyRowsToClipboard';
import {getClipboardColumns} from '../utils/getClipboardColumns';
import {resolveRowClipboardCopyTarget} from '../utils/resolveRowClipboardCopyTarget';

export function useRowClipboard(rowId: string, definitions: EagColumn[]) {
  const store = useEagGridStore();
  const canCopyRow = useEagGridSelector((state) =>
    isNotNil(resolveRowClipboardCopyTarget(state, rowId, getClipboardColumns(state, definitions)))
  );

  const copyRow = () => {
    const state = store.getState();
    const target = resolveRowClipboardCopyTarget(
      state,
      rowId,
      getClipboardColumns(state, definitions)
    );
    if (isNotNil(target)) {
      void copyRowsToClipboard(target.rows, target.columns, 'DATA');
    }
  };

  return {canCopyRow, copyRow};
}
